import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { pipe } from 'fp-ts/lib/function';
import { callRedo } from 'utils/history/CallbackHistory';

export const redo: GraphCommandFactory = (cmdContext) => () => {
  pipe(cmdContext.getState().history, callRedo, (history) =>
    cmdContext.updateState((draft) => {
      draft.history = history;
    }),
  );
};
